<template>
    <div class="navbar">
        <nav>
            <input type="checkbox" v-model="checkboxx.valor" id="check"/>
            <label v-if="!checkboxx.valor" for="check" class="check-btn"><img class="menu" src="../../assets/images/menu.svg" alt=""/></label>
            <label v-else for="check" class="check-btn"><img class="menu" width="18" src="../../assets/images/close.svg" style="color: #4F4F4F; " alt=""/></label>
            <a href="/"><img class="logo" src="../../assets/images/planti-logo.svg" alt=""></a>
            <div class="sociais-menu-mob">
                <a href="https://www.facebook.com/Planti-App-118228620091995/" target="_blank"><img class="social mr-3" src="../../assets/images/face.svg" alt=""></a>
                <a href="https://www.instagram.com/plantiapp/" target="_blank"><img class="social mr-2" src="../../assets/images/insta.svg" alt=""></a>
            </div>
            <ul>
                <li><router-link @click.native="disableCheck" to="#definicao" >O que é?</router-link></li>
                <li><router-link @click.native="disableCheck" to="#beneficios" >Benefícios</router-link></li>
                <li class="rsocial"><a href="https://www.facebook.com/Planti-App-118228620091995/" target="_blank"><img class="social " src="../../assets/images/face.svg" alt=""></a></li>
                <li class="rsocial"><a href="https://www.instagram.com/plantiapp/" target="_blank"><img class="social" src="../../assets/images/insta.svg" alt=""></a></li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'Navbar',
    data() {
        return {
            checkboxx: {
                valor: false
            }
        }
    },
    methods: {
        disableCheck() {
            this.checkboxx.valor = false;
        }
    }
}
</script>

<style scoped lang="scss">
#check, .check-btn, .sociais-menu-mob, .menu2{
    display: none;
}
*{
  padding: 0;
  margin: 0;
  text-decoration: none;
  list-style: none;
}
.navbar{
    background-color: white;
    height: 60px;
}
.social{
    width: 30px;
}
.logo{
    width: 90px;
    margin-top: -4px;
}
nav{
    padding: 0 80px 0 100px;
    width: 100%;
}
ul {
  float: right;
}
li{
    display: inline-block;
    margin: 0 18px;
}
a{
    font-style: normal;
    font-weight: normal;
    font-size: 23px;
    line-height: 38px;
    letter-spacing: 0.75px;
    color: #4F4F4F;
}
a:active, a:hover, .active{
    font-style: normal;
    font-weight: normal;
    font-size: 23px;
    line-height: 38px;
    letter-spacing: 0.75px;
    color: #00BA88;
    text-decoration: none;
}

@media screen and (max-width: 767px) {
    ul {
        float: right;
        position: fixed;
        width: 100%;
        left: -100%;
        margin-top: 0;
        padding-top: 30px;
        height: 100vh;
        background: #fff;
        text-align: center;
        transition: all .5s;
    }
    #check:checked ~ ul{
        left: 0;
    }
    #check:checked ~ .sociais-menu-mob{
        display: none;
    }
    li{
        display: block;
        margin: 10px 15px;
    }
    .rsocial{
        display: inline-block;
    }
    .navbar{
        height: 50px;
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        z-index: 99;
    }
    nav{
        padding: 0 0 0 20px;
        width: 100%;
    }
    .logo{
        width: 80px;
        margin-top: -9px;
        margin-left: 20px;
    }
    .social{
        margin-top: -7px;
    }
    .sociais-menu-mob{
        display: inline-block;
        float: right;
    }
    .check-btn{
        display: inline-block;
    }
    .menu{
        cursor: pointer;
        margin-top: -10px;
    }
}

</style>
